import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Header } from '@tanstack/react-table';
import { PricingAggregateCell } from '@sales-portal/domain/pricing/components/pricing-aggregate-cell';
import { View } from 'react-native';

interface PricingAggregateRowProps<TData> {
  data: TData;
  editsCount: number;
  headers: Header<TData, unknown>[];
  isDeltaColumn: (columnId: string) => boolean;
  isLeftAlignedColumn: (columnId: string) => boolean;
  testID?: string;
}

export const PricingAggregateRow = <TData,>({
  data,
  editsCount,
  headers,
  isDeltaColumn,
  isLeftAlignedColumn,
  testID,
}: PricingAggregateRowProps<TData>) => {
  const [styles] = useStyles();

  return (
    <View style={styles.row} testID={testID}>
      {headers.map((header) => (
        <PricingAggregateCell
          data={data}
          editsCount={editsCount}
          header={header}
          isDeltaColumn={isDeltaColumn}
          isLeftAlignedColumn={isLeftAlignedColumn}
          key={header.column.id}
        />
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  row: {
    borderBottomColor: theme.sk.color.border.primary,
    borderBottomWidth: 1,
    flexDirection: 'row',
  },
}));
